import React, { Component } from "react";
import ScrollProgressIndicator from "components/ScrollProgressIndicator/ScrollProgressIndicator";
import TappableStayComponent from "components/TappableStayComponent/TappableStayComponent";
import "./TapRating.scss";

export default class TapRating extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.actions.initComponentRatings();
  }

  buildComponentList = () =>
    this.props.stayComponents.map(component => (
      <TappableStayComponent
        actions={this.props.actions}
        componentComment={component.AnswerComment}
        componentRating={component.AnswerRating}
        componentID={component.SurveyComponentId}
        didNotRun={component.DidNotRun}
        displayName={component.SurveyDisplayName}
        key={component.SurveyComponentId}
      />
    ));

  render() {
    const surveyData = this.props.surveyData;
    const locationIndex = this.props.locationIndex;
    const stayName = surveyData.StaySubmissions[locationIndex].StayName;
    const currentQuestion =
      surveyData.StaySubmissions[locationIndex].ComponentQuestion;
    const questionText = currentQuestion.Text;

    return (
      <section className="tap-rating">
        <header className="tap-rating__header">
          <h1 className="tap-rating__header__name">{stayName}</h1>
          <h2 className="tap-rating__header__question">{questionText}</h2>
          <ScrollProgressIndicator />
        </header>

        <section className="tap-rating__components">
          {this.buildComponentList()}
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./application/containers/TapRating/TapRating.jsx